import { Accordion, Button, Card, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Loader from "../loaders/Loader";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

export default function AnalisysForm({ state, workOrder, handleInputChange, submit, isAddingOrEditing, isRegistering, userType }) {
    const { t } = useTranslation()
    const [samples, setSamples] = useState([])
    const [sampleName, setSampleName] = useState(1)

    useEffect(() => {
        if (workOrder?.analisysType) {
            if (JSON.stringify(samples) !== JSON.stringify(state.measures)) {
                setSamples(state.measures || []);
            }
        }
    }, [workOrder?.analisysType, state.measures]);

    useEffect(() => {
        handleInputChange({ target: { name: "measures", value: samples } });
        setSampleName(samples.length ? parseInt(samples[samples.length - 1].sample) + 1 : 1)
    }, [samples])

    const addSample = () => {
        if (workOrder?.analisysType && workOrder?.analisysType.params) {
            const newSample = {
                sample: sampleName,
                params: workOrder?.analisysType.params.map(param => ({
                    parameterReferenced: param.parameter._id,
                    parameter: param.parameter.name,
                    unitMeasure: param.unitMeasure || "",
                    minValue: param.minValue || 0,
                    maxValue: param.maxValue || 0,
                    value: null,
                    batch: ""
                }))
            }
            setSamples([...samples, newSample])
            setSampleName(parseInt(sampleName) + 1)
        }
    }

    const removeSample = (index) => {
        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.accept'),
            cancelButtonText: t('global.cancel'),
            icon: 'warning',
            html: t('admin.analises.areyousureremoveSample')
        }).then((result) => {
            if (result.isConfirmed) {
                setSamples(samples.filter((_, i) => i !== index))
            }
        })

    }

    const updateSampleParam = (sampleIndex, paramIndex, key, value) => {
        const updatedSamples = [...samples]
        if (key === 'value') {
            updatedSamples[sampleIndex].params[paramIndex][key] = value === '' ? '' : value
        } else {
            updatedSamples[sampleIndex].params[paramIndex][key] = value
        }
        setSamples(updatedSamples)
    }

    return (
        state ?
            <>
                <Form onSubmit={submit} className="px-4 formulario">
                    <Row className="my-3">
                        <Col xs={12} md={4}>
                            <Form.Label>{t('admin.analises.workOrder')}</Form.Label><br/>
                            <Form.Label>{new Date(workOrder?.date).getFullYear()}-{String(workOrder?.numWorkOrder).padStart(4, '0')}</Form.Label>
                        </Col>
                        <Col xs={12} md={4}>
                            <Form.Label>{t('admin.analises.workOrderDate')}</Form.Label><br/>
                            <Form.Label>{workOrder?.date ? new Date(workOrder?.date).toLocaleDateString('es-ES') : ''}</Form.Label>
                        </Col>
                        {/* <Col xs={12} md={4}>
                            <Form.Label>{t('admin.analises.date')}</Form.Label>
                            {userType === 'Admin' ?
                                <Form.Control
                                    className="sd-input"
                                    type='datetime-local'
                                    name='date'
                                    value={state.date || new Date()}
                                    onChange={handleInputChange}
                                    required
                                />
                            :
                                <><br/>{state.date ? new Date(state.date).toLocaleString('es-ES') : ''}</>
                            }
                        </Col> */}
                        {userType === 'Admin' ?
                            <Col xs={12} md={4}>
                                <Form.Label>{t('admin.analises.enterSampleName')}</Form.Label>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Control
                                            className="sd-input"
                                            type="number"
                                            value={sampleName}
                                            onChange={(e) => setSampleName(e.target.value)}
                                        />
                                    </Col>
                                    <Col xs={6}>
                                        <Button variant="success" onClick={addSample}>{t('admin.analises.addSample')}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        :
                            ''
                        }
                    </Row>

                    <Accordion>
                        {samples.slice().reverse().map((sample, sampleIndex) => (
                            <div key={sampleIndex}>
                                <Accordion.Item eventKey={sampleIndex.toString()} className="my-2">
                                    <Accordion.Header className="w-100 d-flex align-items-center">
                                        <Row className="w-100">
                                            <Col xs={4} className="d-flex text-start">
                                                {userType === 'Admin' &&
                                                    <Button
                                                        variant="third"
                                                        className="p-0 me-3"
                                                        onMouseDown={(e) => e.stopPropagation()}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            removeSample(samples.length - 1 - sampleIndex);
                                                        }}
                                                    >
                                                        <i className="fas fa-trash" />
                                                    </Button>
                                                }
                                                {new Date(workOrder?.date).getFullYear()}-{String(workOrder?.numWorkOrder).padStart(4, '0')}-{String(sample.sample).padStart(4, '0')}
                                            </Col>
                                            <Col xs={4} className="text-center">
                                                {t('admin.parameters.verified')}: {sample?.params?.filter(param => param.status === 'done')?.length}/{sample?.params?.length}
                                            </Col>
                                            <Col className="flex-grow-1 text-danger">

                                                {sample?.params?.filter(param => param.status === 'done' && param.value !== '' && (param.value < param.minValue || param.value > param.maxValue))?.length > 0
                                                ?
                                                    <>
                                                        <i className="fas fa-exclamation-triangle me-1"></i>
                                                        <span className="ms-1">{sample?.params?.filter(param => param.status === 'done' && param.value !== '' && (param.value < param.minValue || param.value > param.maxValue))?.length}</span>
                                                    </>
                                                :
                                                    <></>
                                                }
                                            </Col>
                                        </Row>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col xs={6} md={1}></Col>
                                            <Col xs={6} md={3}>
                                                <Form.Label>{t('admin.parameters.parameter')}</Form.Label>
                                            </Col>
                                            <Col xs={6} md={2}>
                                                <Form.Label>{t('admin.parameters.range')}</Form.Label>
                                            </Col>
                                            <Col xs={6} md={3}>
                                                <Form.Label>{t('admin.parameters.value')}</Form.Label>
                                            </Col>
                                            <Col xs={6} md={3}>
                                                <Form.Label>{t('admin.parameters.batch')}</Form.Label>
                                            </Col>
                                        </Row>
                                        {sample.params.map((param, paramIndex) => (
                                            <Row key={paramIndex} className="mb-2 py-2 border rounded">
                                                <Col xs={6} md={1} className="d-flex align-items-center">
                                                    {userType === 'Admin' ?
                                                        param.status === 'done' ?
                                                            <img src="../images/check.svg" alt="check" width={15}></img>
                                                        :
                                                            <img src="../images/times.svg" alt="times" width={15}></img>
                                                    :
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={param?.status !== 'pending'}
                                                            onChange={(e) => updateSampleParam(samples.length - 1 - sampleIndex, paramIndex, 'status', e.target.checked ? 'done' : 'pending')}
                                                        />
                                                    }
                                                </Col>
                                                <Col xs={6} md={3} className="d-flex align-items-center">
                                                    <Form.Label>
                                                        {typeof param.parameter === "object" ? param.parameter.name : param.parameter}
                                                    </Form.Label>
                                                </Col>
                                                <Col xs={6} md={2} className="d-flex align-items-center">
                                                    {param.minValue} {param.unitMeasure} - {param.maxValue} {param.unitMeasure}
                                                </Col>
                                                <Col xs={6} md={3} className="d-flex align-items-center">
                                                    {userType === 'Admin' ?
                                                        param.value + ' ' + param.unitMeasure
                                                    :
                                                        <>
                                                            <Form.Control
                                                                className="me-1 sd-input"
                                                                type="number"
                                                                step="any"
                                                                value={param.value}
                                                                onChange={(e) => updateSampleParam(samples.length - 1 - sampleIndex, paramIndex, 'value', e.target.value)}
                                                                style={{
                                                                    borderColor: param.value < param.minValue || param.value > param.maxValue ? 'red' : '',
                                                                    borderWidth: param.value < param.minValue || param.value > param.maxValue ? '2px' : '',
                                                                }}
                                                                readOnly={param?.status !== 'pending'}
                                                            /> {param.unitMeasure}
                                                        </>
                                                    }
                                                </Col>
                                                <Col xs={6} md={3} className="d-flex align-items-center">
                                                    {userType === 'Admin' ?
                                                        param?.batch || '-'
                                                    :
                                                        <Form.Control
                                                            className="sd-input"
                                                            type="text"
                                                            value={param.batch}
                                                            onChange={(e) => updateSampleParam(samples.length - 1 - sampleIndex, paramIndex, 'batch', e.target.value)}
                                                            readOnly={param.status !== "pending"}
                                                        />
                                                    }
                                                </Col>
                                            </Row>
                                        ))}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </div>
                        ))}
                    </Accordion>
                    <Row className="my-3">
                        <Col xs={12} className="my-2 d-flex justify-content-end">
                            <Button variant='primary' type="submit" className="my-2">
                                {isRegistering ? (
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                ) : isAddingOrEditing === 'editing' ? (
                                    <>{t('global.edit')}</>
                                ) : (
                                    <>{t('global.register')}</>
                                )}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </>
        :
            <Loader/>
    );
}
